export function formatPrice(price, unit) {
  if (price >= 10000000) {
    const v = price / 10000000;
    return `₹${(v % 1 === 0 ? v.toFixed(0) : v.toFixed(2))} Cr`;
  }
  if (price >= 100000) {
    const v = price / 100000;
    return `₹${(v % 1 === 0 ? v.toFixed(0) : v.toFixed(2))} Lac`;
  }
  return `₹${Number(price).toLocaleString("en-IN")}`;
}

export function areaLabel(unit) {
  return { sqft: "sq.ft", sqyd: "sq.yd", acre: "acre" }[unit] || unit;
}

export const slugify = (t) =>
  String(t || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || "location";

export const PROPERTY_TYPES = [
  { value: "agricultural", label: "Agricultural Land" },
  { value: "plot", label: "Plot / Residential Land" },
  { value: "apartment", label: "Apartment" },
  { value: "villa", label: "Villa / House" },
  { value: "commercial", label: "Commercial" },
];

export const FACING_OPTIONS = ["East", "West", "North", "South", "North-East", "North-West", "South-East", "South-West"];
export const APPROVAL_OPTIONS = ["DTCP", "HMDA", "Panchayat", "NALA", "Patta / Clear Title", "Other"];

export const CITIES = [
  { name: "Hyderabad", lat: 17.385, lng: 78.4867 },
  { name: "Bangalore", lat: 12.9716, lng: 77.5946 },
  { name: "Chennai", lat: 13.0827, lng: 80.2707 },
  { name: "Mumbai", lat: 19.076, lng: 72.8777 },
  { name: "Pune", lat: 18.5204, lng: 73.8567 },
];
